<template>
  <Modal
    ref="modal"
    bgcolor="rgba(0,0,0,0.3)"
    :closeable="false"
  >
    <div class="tour-guide-modal">
      <Form
        v-if="step===1"
        @submit="onSubmit"
        @hide="hide"
      />
      <Ringing
        v-else-if="step===2"
        :form-data="formData"
        @hide="hide"
        @showCalendar="showCalendar"
      />
    </div>
  </Modal>
</template>

<script>
// import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import Modal from '../../../IModal'
import Ringing from './Ringing'

export default {
  name: 'ModalTourGuide',
  components: {
    Modal,
    Ringing
  },
  data () {
    return {
      step: 1,
      formData: {}
    }
  },

  computed: {
    ...mapGetters([
      'currentBuilding'
    ])
  },

  methods: {
    ...mapActions([
      'setGuideWindowActive'
    ]),

    show () {
      this.setGuideWindowActive(true)
      this.$refs.modal.show()
    },

    hide () {
      this.step = 1
      this.$refs.modal.hide()
      this.setGuideWindowActive(false)
      this.$emit('close')
    },

    onSubmit (formData) {
      this.formData = formData
      this.step++
    },

    showCalendar () {
      this.$emit('showCalendar')
      this.hide()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';
@import '~css/common/extends'

.tour-guide-modal {
  @extend .scrollbar-narrow
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100%;

  @media (min-width: $response) {
    display: block;
    position: relative;
    border-radius: 0.625rem;
    max-height: 95%;
  }

  & > form {
    max-height: 100%;
  }
}
</style>
